import React from "react"
import Grid from "@mui/material/Grid2";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import ReturnToStartScreenTimer from "../Common/ReturnToStartScreenTimer";

interface MoveFailedProps {
    paymentDone: boolean
    error?: string
}

const MoveFailed = ({ paymentDone, error }: MoveFailedProps) => {
    const { t } = useTranslation()

    const translateError = (error: string): string => {
        switch (error) {
            case 'online_check_in_failed_not_paid':
                return t('selfService.checkInErrors.notPaid')

            case 'online_check_in_failed_reservation_is_removed':
                return t('selfService.checkInErrors.reservationRemoved')

            case 'online_check_in_atj_search_failed':
                return t('selfService.checkInErrors.atjSearchFailed')

            default:
                return error
        }
    }

    const text = paymentDone ? t('selfService.paymentSucceeded') : null
    const errorText = error ? translateError(error) : null

    return (
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className="pageMainContainer">
            <Grid/>
            <Grid justifyItems="center" className="contentWithMargin">
                <Typography variant="h4" gutterBottom>{t('selfService.notInWorkQueue')}</Typography>
                <Typography variant="subtitle1" gutterBottom>
                    {t('selfService.notInWorkQueueInfo')}
                </Typography>
            </Grid>
            {(text || errorText) && <Grid justifyItems="center" className="contentWithMargin">
                {text && <Typography variant="subtitle1" gutterBottom>{text}</Typography>}
                {errorText && <Typography variant="subtitle1" gutterBottom>{errorText}</Typography>}
            </Grid>}
            <ReturnToStartScreenTimer time={60}/>
            <Grid/>
        </Grid>
    )
}

export default MoveFailed
